var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper1"},[_c('h3',{staticClass:"newDetial-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"newDetial-time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(this.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }